<template>
  <div>
    <AiCommonBanner
      styleHeading="Internet of Things"
      heading="Connect.Automate.Empower"
      paragraph=" Unify and control your device ecosystem"
    />
    <CommonClients :images="images" :isIOTPage="true" />

    <div class="ai-container">
      <h2
        class="common-banner-heading text-center"
        style="font-weight: bold !important; margin-bottom: 20px"
      >
         Empowering your business <br />with Advance IoT 
      </h2>

      <div class="custom-container">
        <div class="custom-col" v-for="(img, index) in aiProducts" :key="index">
          <div v-if="!img.isDescShow">
            <div class="custom-icon">
              <img
                :src="`/assets/img/ai/${img.icon}.svg`"
                alt="Product images"
              />
            </div>
            <h2 class="text-align">{{ img.text }}</h2>
            <i
              class="fa fa-arrow-right fix-icon"
              @click="img.isDescShow = true"
            ></i>
          </div>
          <div v-else>
            <div>
              <p class="p-desc">{{ img.desc }}</p>
              <i
                class="fa fa-arrow-left fix-icon"
                @click="img.isDescShow = false"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <AiClients :aiImages="AiImages" /> -->
    <div class="ai-container">
      <h2
        class="common-banner-heading text-center"
        style="font-weight: bold; margin-bottom: 50px !important"
      >
        Our IoT Projects

      </h2>
      <div class="audio-to-text-container">
        <h2
          class="text-align"
          style="
            text-align: left !important;
            font-weight: 800;
            width: 100%;
            font-size: 40px;
          "
        >
          Audio to Text
        </h2>
        <img
          src="/assets/img/iot/sereniby-main.png"
          class=""
          alt="Audio To Text"
        />
      </div>
    </div>
    <div class="ai-container">
      <div class="ai-bot-grid">
        <div
          class="ai-bot-card"
          v-for="(item, index) in audioToText"
          :key="index"
        >
          <h2 class="align-item">{{ item.title }}</h2>
          <img :src="`/assets/img/iot/${item.image}`" alt="image" width="100%" />
          <!-- <img src="/assets/img/iot/posture-detection.png" alt="" width="100%" /> -->
        </div>
      </div>
    </div>

    <div class="col-container">
      <div class="col" v-for="(item, index) in aiIntegration" :key="index">
        <div class="icon">
          <img :src="`/assets/img/ai/${item.icon}`" alt="Integration image" />
        </div>
        <h2 class="align-item">
          {{ item.title }}
        </h2>
        <p class="p-desc">
          {{ item.desc }}
        </p>
      </div>
    </div>
    <h2
      class="common-banner-heading text-center"
      style="font-weight: bold; margin: 40px 0"
    >
      Portfolio
    </h2>
    <div class="ai-portfolio-container iot-portfolio">
      <div class="ai-portfolio-grid" style="padding: 40px 0 !important">
        <div class="ai-portfolio-card-left">
          <div class="ai-portfolio-logo">
            <img class="textt-log" src="/assets/img/iot/primal.png" alt="" width="100%" />
          </div>

          <h1 class="ai-portfolio-heading">
            Primal Plunge
          </h1>
          <p class="custom-desc" style="text-align: left !important">
           A mobile app that lets users control cold plunge chillers, track sessions, and access wellness content-powered by Tuya IoT, real-time connectivity, and intuitive onboarding for optimized recovery.
          </p>
          <button class="btn custom-btn" @click="navigateTo('/portfolio')">
            view more
          </button>
        </div>
        <div class="ai-portfolio-card-right">
          <img
            src="/assets/img/iot/primal-main.png"
            alt="Moke up image"
            width="100%"
          />
        </div>
      </div>
    </div>
    <div class="ai-portfolio-container iot-portfolio" style="background: black !important">
      <div class="ai-portfolio-grid" style="padding: 40px 0 !important">
        <div class="ai-portfolio-card-right klugar-img">
          <img 
            src="/assets/img/iot/Klugar-main.png"
            alt="Moke up image"
            width="100%"
          />
        </div>
        <div class="ai-portfolio-card-left">
          <div class="ai-portfolio-logo">
            <img
              src="/assets/img/iot/klugar-logo-text.png"
              alt=""
              width="100%"
              class="cap-img textt-log"
            />
          </div>

          <h1 class="ai-portfolio-heading">
           Klugar
          </h1>
          <p class="custom-desc" style="text-align: left !important">
            Kluger, a leading German smart home brand, sought to develop a mobile application that provides seamless local and remote control for over 100 smart home products. The goal was to create an secure, and scalable lot solution that enhances user experience while supporting diverse automation.
          </p>
          <button class="btn custom-btn" @click="navigateTo('/portfolio')">
            view more
          </button>
        </div>
      </div>
    </div>
    <div class="ai-portfolio-container iot-portfolio">
      <div class="ai-portfolio-grid">
        <div class="ai-portfolio-card-left">
          <div class="ai-portfolio-logo">
            <img class="textt-log"
              src="/assets/img/iot/gtensor-logo-text.png"
              alt=""
              width="auto"
              height="100%"
            />
          </div>

          <h1 class="ai-portfolio-heading" style="color: #8ca530 !important">
            GTensor
          </h1>
          <p class="custom-desc" style="text-align: left !important">
            GTensor is dedicated to solving the global energy and environmental crisis by developing intelligent systems that reduce waste and harness renewable resources. Believing in the power of networking and individual potential, we champion eco-friendly energy production and pollution reduction.
          </p>
          <button class="btn custom-btn" @click="navigateTo('/portfolio')">
            view more
          </button>
        </div>
        <div class="ai-portfolio-card-right">
          <img
            src="/assets/img/iot/GTensor.png"
            alt="Moke up image"
            style="height: 360px; object-fit: contain"
            width="100%"
          />
        </div>
      </div>
    </div>
    <div class="ai-portfolio-container iot-portfolio" style="background: black !important">
      <div class="ai-portfolio-grid" style="padding: 40px 0 !important">
        <div class="ai-portfolio-card-right">
          <img
            src="/assets/img/iot/cayka-mian.png"
            alt="Moke up image"
            width="100%"
          />
        </div>
        <div class="ai-portfolio-card-left">
          <div class="ai-portfolio-logo">
            <img class="textt-log" src="/assets/img/iot/cayka-logo.png" alt="" width="100%" />
          </div>
          <h1 class="ai-portfolio-heading" style="color: #69d6ef !important">
            Cayka
          </h1>
          <p class="custom-desc" style="text-align: left !important">
            A flexible mobile app to control and monitor smart devices like adapters, switches, and lamps via Wi-Fi, Bluetooth, and MQTT -with real-time status, remote access, and customizable control panels.
          </p>
          <button class="btn custom-btn" @click="navigateTo('/portfolio')">
            view more
          </button>
        </div>
      </div>
    </div>
    <div class="ai-portfolio-container iot-portfolio">
      <div class="ai-portfolio-grid">
        <div class="ai-portfolio-card-left">
          <div class="ai-portfolio-logo">
            <img class="textt-log"
              src="/assets/img/iot/simiconnect-logo.png"
              alt=""
              width="auto"
              height="100%"
            />
          </div>

          <h1 class="ai-portfolio-heading">
             <span style="color:#00d6ed !important">Simi</span> Connect
          </h1>
          <p class="custom-desc" style="text-align: left !important">
            Simi Connect is a Platform that offers various sub-applications one of which is Simi Smart. Simi Smart is a Home automation application through which users can control various home appliances like smart bulbs, smart cameras, smart thermostats, smart plugs, and much more.          </p>
          <button class="btn custom-btn" @click="navigateTo('/portfolio')">
            view more
          </button>
        </div>
        <div class="ai-portfolio-card-right">
          <img
            src="/assets/img/iot/simi-connect-main.png"
            alt="Moke up image"
            style="height: 360px; object-fit: contain"
            width="100%"
          />
        </div>
      </div>
    </div>
    <!-- new block start -->
     <div class="ai-portfolio-container iot-portfolio" style="background: black !important">
      <div class="ai-portfolio-grid" style="padding: 40px 0 !important">
        <div class="ai-portfolio-card-right">
          <img
            src="/assets/img/iot/zimi-main.png"
            alt="Moke up image"
            width="100%"
          />
        </div>
        <div class="ai-portfolio-card-left">
          <div class="ai-portfolio-logo">
            <img class="textt-log" src="/assets/img/iot/Zimi-logo-text.png" alt="" width="100%" />
          </div>
 
          <h1 class="ai-portfolio-heading">
            Zimi
          </h1>
          <p class="custom-desc" style="text-align: left !important">
Zimi specializes in smart home technology focused on sustainability and simplicity, enhancing living spaces with user-friendly, eco-conscious devices. Their innovative Zimi app seamlessly integrates with a variety of products for a smarter living environment.          </p>
          <button class="btn custom-btn" @click="navigateTo('/portfolio')">
            view more
          </button>
        </div>
      </div>
    </div>
    <!-- new block end -->
     <div class="ai-portfolio-container iot-portfolio">
      <div class="ai-portfolio-grid">
        <div class="ai-portfolio-card-left">
          <div class="ai-portfolio-logo">
            <img class="textt-log"
              src="/assets/img/iot/axios-logo.png"
              alt=""
              width="auto"
              height="100%"
            />
          </div>

          <h1 class="ai-portfolio-heading">
            Axxios
          </h1>
          <p class="custom-desc" style="text-align: left !important">
          Axxios is a Home Automation application that uses various Data Transfer Protocols such as Wifi, IP, Bluetooth, Zigbee & Zwave to connect to Smart Devices like Philips Hue Bulbs+Sengled Bulbs, Yale Locks, Nest Camera, Nest + Ecobee Thermostats.
          </p>
          <button class="btn custom-btn" @click="navigateTo('/portfolio')">
            view more
          </button>
        </div>
        <div class="ai-portfolio-card-right">
          <img
            src="/assets/img/iot/axxios-main.png"
            alt="Moke up image"
            style="height: 360px; object-fit: contain"
            width="100%"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CommonBanner from "@/views/common/CommonBanner.vue";
import AiCommonBanner from "@/views/common/AiCommonBanner.vue";
import AiClients from "@/views/common/AiClients.vue";
import CommonClients from "@/views/common/CommonClients.vue";
export default {
  name: "ArtificialIntelligence",
  components: { AiClients, AiCommonBanner, CommonBanner, CommonClients },
  data() {
    return {
      AiImages: [
        "open-ai.svg",
        "bard.svg",
        "llma.svg",
        "chatgpt.svg",
        "open-ai.svg",
        "bard.svg",
        "llma.svg",
        "chatgpt.svg",
      ],
      images: [
        "primal.png",
        "Zimi-logo.png",
        "axios-logo.png",
        "cayka-logo.png",
        "sereniby.png",
        "gtensor-logo.png",
        "klugar-logo.png",
      ],
      aiProducts: [
        {
          icon: "natural-language",
          text: "Smart Device Ecosystem",
          desc:
            "A single app to manage a variety of smart devices—plugs, switches, lamps—across Wi‑Fi and Bluetooth using MQTT-based infrastructure." +
            "Automatic discovery and secure pairing of new devices." +
            "Multi-protocol support ensures compatibility with most manufacturers",
          isDescShow: false,
        },
        {
          icon: "computer-vision",
          text: "Real-Time Control & Monitoring",
          desc:
            "Whether it’s lights, adapters, or thermostats, get instant control and full visibility." +
            "Live status updates and device state control (on/off, dimming, temperature) " +
            "Historical usage analytics for informed decision-making ",

          isDescShow: false,
        },
        {
          icon: "deep-learning",
          text: "Dynamic Control Panels",
          desc:
            "Customizable UI widgets tailored to each device type for a unified user experience." +
            "Drag‑and‑drop control panel setup" +
            "Add, remove, or reorganize device controls on‑the‑fly",

          isDescShow: false,
        },
        {
          icon: "machine-learning",
          text: "Cloud & Local Flexibility",
          desc:
            "Built with both local responsiveness and cloud‑based convenience in mind." +
            "Edge‑first design ensures offline functionality" +
            "Secure cloud syncing for multi‑device setups and remote access",

          isDescShow: false,
        },
        {
          icon: "data-science",
          text: "Scalable & Extendable Architecture",
          desc:
            "Future‑ready structure with modular backend and flexible integrations." +
            "MQTT broker backbone with extensible device command routing" +
            "Ideal for evolving smart home ecosystems and feature expansion",

          isDescShow: false,
        },
        {
          icon: "large-language",
          text: "Secure by Design",
          desc:
            "Privacy and resilience built into every interaction." +
            "Encrypted local and cloud communications" +
            "Role‑based access, OTA updates, and firmware control via the app",

          isDescShow: false,
        },
        {
          icon: "custom-models",
          text: " Value Delivered",
          desc:
            "Unlock smarter living with IoT that just works:" +
            "Faster setup → less friction for users" +
            "Faster setup → less friction for users" +
            "Deeper analytics unlock insights and automation possibilities",

          isDescShow: false,
        },
        {
          icon: "training-data",
          text: "training data management",
          desc:
            "High-quality training data is essential for effective AI models. " +
            "We provide training data management services to ensure your " +
            "data is clean, labeled accurately, and optimized for your chosen AI model.",

          isDescShow: false,
        },
      ],
      aiIntegration: [
        {
          icon: "ai-consulting.svg",
          title: "IoT Strategy & Consulting",
          desc:
            "We help organizations unlock the potential of the Internet of Things by identifying impactful use cases and creating data-driven, AI-enhanced strategies. From sensor selection to connectivity and cloud architecture, our IoT consultants guide you through every step of the journey—ensuring your investment drives measurable business outcomes.",
        },
        {
          icon: "ai-product.svg",
          title: "End-to-End IoT Product Development",
          desc:
            "Whether you're launching a new connected product or upgrading an existing one, our team offers full-cycle IoT development services—from hardware integration and firmware to mobile/web apps, dashboards, and cloud platforms. We specialize in building scalable, secure, and user-friendly IoT solutions that work seamlessly across devices and networks.",
        },
        {
          icon: "ai-agile.svg",
          title: "Agile IoT Engineering Teams",
          desc:
            "Accelerate development with our dedicated IoT squads. Built around agile delivery, our teams include embedded systems engineers, full-stack developers, DevOps, and data specialists who collaborate closely with your product team. This ensures rapid iteration, technical alignment, and faster time-to-market for your IoT initiatives.",
        },
      ],
      audioToText: [
        {
          title: "Sleep Posture Monitoring",
          image: "posture-detection.png",
        },
        {
          title: "Facial Activity Mapping",
          image: "face-mesh.png",
        },
        {
          title: "Eye Engagement Detection",
          image: "eye-contact.png",
        },
      ],
    };
  },
  methods: {
    navigateTo(route) {
      this.$router.push(route).then(() => {
        window.scrollBy(0, 500);
      });
    },
  },
};
</script>
<style>
.custom-container {
  margin: 0 !important;
  width: 100%;
  display: grid;
  gap: 20px;
  padding: 10px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}
.custom-col {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
  border: 1px solid #fff;
  justify-content: start;
  height: 240px;
  border-radius: 8px;
}
.custom-col .custom-icon {
  width: 66px;
  height: 66px;
  margin-bottom: 15px;
}
.custom-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain; /* Ensures the image covers the container while maintaining its aspect ratio */
}
.custom-col .text-align {
  text-align: left !important;
  font-weight: 700 !important;
  font-size: 20px;
  font-family: "Nunito";
  line-height: 28px;
  text-transform: uppercase;
}
.custom-col:hover {
  border: 1px solid #00b398;
}
.custom-col .fix-icon {
  position: absolute;
  left: 15px;
  bottom: 10px;
  font-size: 16px;
  line-height: 20px;
  color: #fff;
  cursor: pointer;
}
.ai-portfolio-container {
  width: 100vw;
  padding: 20px 8% !important;
  background-color: #131313;
}
.ai-container {
  width: 84%;
  margin: 30px auto !important;
  padding: 20px 0 !important;
}
.ai-container .ai-grid {
  width: 100%;
  padding: 30px 0 !important;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 25px;
}
.ai-card {
  width: 100%;
  padding: 15px;
  border-radius: 12px;
  border: 1px solid #626161;
}
.ai-card.custom-card {
  height: 270px !important;
}
.ai-card.custom-card .icon-image {
  margin-bottom: 90px !important;
}
.custom-desc {
  font-family: "Poppins";
  font-size: 18px;
  font-weight: 400;
  line-height: 30px;
  margin-bottom: 1rem;
}
.ai-card:hover {
  border: 1px solid #00b398;
}
.ai-card .icon-image {
  width: 40px;
  height: 40px;
  margin-bottom: 30px;
}
.icon-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.ai-container .audio-to-text-container {
  width: 100%;
  padding: 20px 30px;
  border-radius: 12px;
  border: 1px solid #626161;
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 40px;
}
.audio-to-text-container img {
  width: 100%;
  height: auto;
}
.ai-container .integration-grid {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 30px;
}
.ai-portfolio-grid {
  width: 100%;
  display: grid;
  gap: 40px;
  grid-template-columns: 1fr 1fr;
  padding: 20px 0 !important;
}
.ai-portfolio-grid .ai-portfolio-card-left {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.ai-portfolio-grid .ai-portfolio-card-right {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ai-portfolio-card-right img {
  width: 80%;
  height: auto;
}
.ai-portfolio-card-left .ai-portfolio-logo {
  width: 215px;
  height: 72px;
  object-fit: contain;
  margin-bottom: 20px !important;
}
.ai-portfolio-card-left .ai-portfolio-heading {
  font-family: "Nunito";
  font-size: 40px;
  line-height: 41px;
  font-weight: 800;
  color: #f2f2f2;
  letter-spacing: normal;
}

.custom-btn {
  width: 185px;
  background-color: #00b398;
  padding: 10px;
  margin-right: 0 !important;
  text-transform: capitalize;
  border-radius: 12px;
  font-size: 16px;
  font-family: "Nunito", sans-serif;
  font-weight: 600;
  color: #fff;
  margin-top: 1.2rem;
}
.ai-container .ai-bot-grid {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 30px;
}
.ai-bot-grid .ai-bot-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #626161;
  border-radius: 12px;
}
.ai-bot-card img {
  width: 100%;
  height: 100%;
}
.common-banner-heading {
  font-size: 40px !important;
  font-weight: 700 !important;
  line-height: 54px !important;
  letter-spacing: normal;
}




.klugar-img img{
  width: 65% !important;
}

.ai-portfolio-card-left img {
	width: auto !important;
	max-width: 230px !important;
}


.iotlogo.iotpagelogo img {
	width: 60%;
}





















@media (min-width: 1500px) {
  .custom-desc {
    font-size: 22px !important;
    margin-bottom: 30px !important;
    line-height: 40px !important;
  }
}
@media (max-width: 768px) {
  .custom-container {
    margin: 0 !important;
    width: 100%;
    display: grid;
    gap: 20px;
    padding: 10px;
    grid-template-columns: 1fr 1fr;
  }
  .ai-container {
    width: 75%;
  }
  .ai-portfolio-container {
    padding: 20px 14% !important;
  }
  .ai-grid {
    grid-template-columns: repeat(2, 1fr) !important;
  }
  .audio-to-text-container {
    grid-template-columns: repeat(1, 1fr) !important;
  }
  .audio-to-text-container .text-align {
    text-align: center !important;
  }
  .ai-bot-grid {
    grid-template-columns: repeat(1, 1fr) !important;
    width: 70% !important;
    margin: 30px auto !important;
  }
  .integration-grid {
    grid-template-columns: repeat(1, 1fr) !important;
    width: 70% !important;
    margin: 30px auto !important;
  }
  .ai-portfolio-grid {
    grid-template-columns: repeat(1, 1fr) !important;
  }
}
@media (max-width: 480px) {
  .ai-container {
    width: 84%;
    margin: 10px auto !important;
  }
  .ai-grid {
    grid-template-columns: repeat(1, 1fr) !important;
  }
  .ai-bot-grid {
    width: 100% !important;
    margin: 30px 0 !important;
  }
  .integration-grid {
    width: 100% !important;
  }
  .common-banner-heading {
    font-size: 20px !important;
    font-weight: 700 !important;
    line-height: 27px !important;
  }
  .custom-container {
    margin: 0 !important;
    width: 100%;
    display: grid;
    gap: 20px;
    padding: 10px;
    grid-template-columns: 1fr;
  }
  .cap-img {
    width: 120px !important;
    object-fit: contain;
  }
  .ai-portfolio-card-left img.textt-log {
	  max-width: 65% !important;
  }
  .iot-portfolio .ai-portfolio-card-left .ai-portfolio-logo{
	  height: 47px !important;
  }
  .iot-portfolio .ai-portfolio-logo {
	    height: 50px !important;
  }
}
</style>
<style scoped>

.testimonials-container img {
	width: 70%;
}

</style>